export default __webpack_public_path__ + "static/media/sadem3.8894102f.jpg";